var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 16,
    viewBox: "0 0 12 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.8724 1.04194C10.7629 0.984945 10.6437 0.956445 10.5244 0.956445C10.3744 0.956445 10.2259 1.00144 10.0977 1.08994L0.347664 7.83994C0.145164 7.98019 0.0244141 8.21044 0.0244141 8.45644C0.0244141 8.70244 0.145164 8.93269 0.347664 9.07294L10.0977 15.8229C10.3264 15.9812 10.6257 15.9999 10.8724 15.8709C11.1199 15.7412 11.2744 15.4854 11.2744 15.2064L11.2744 1.70644C11.2744 1.42745 11.1199 1.17169 10.8724 1.04194Z",
    fill: "#6C757D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack);
export default __webpack_public_path__ + "static/media/back.e47626f80c9d1d130c81cf0138d15bba.svg";
export { ForwardRef as ReactComponent };